import { apiRequest } from './client';
import type { AuthSession, ProviderAccountType } from '@/types';

/**
 * ¿Está abierta el alta pública?
 *
 * El alta de proveedores es por invitación: el login lo consulta para elegir
 * entre "Create an account" y "Request an account". Se puede reabrir desde la
 * consola (Configurations → Feature Flags, `provider_self_signup`) sin deploy.
 */
export const getSignupEnabled = () =>
    apiRequest<{ enabled: boolean }>('/auth/signup-enabled', {
        method: 'GET',
        auth: false,
    });

/** Step 1: trigger code email. */
export const sendVerificationCode = (email: string) =>
    apiRequest<{ message: string }, { email: string }>('/auth/send-code', {
        method: 'POST',
        body: { email },
        auth: false,
    });

/** Step 2: verify the 4-digit code. Set verifyOnly=true to keep it alive. */
export const verifyCode = (email: string, code: string, verifyOnly = false) =>
    apiRequest<{ verified: boolean; email: string; accountType?: ProviderAccountType }>('/auth/verify-code', {
        method: 'POST',
        body: { email, code, verifyOnly },
        auth: false,
    });

export interface RegisterPayload {
    email: string;
    code: string;
    password: string;
    firstName: string;
    lastName: string;
    accountType: ProviderAccountType;
    displayName?: string;
    taxId?: string;
    country?: string;
    phone?: string;
    website?: string;
    // Terms of Service + Privacy Policy consent (must be true).
    acceptedTerms: boolean;
    termsVersion?: string;
}

/** Step 3: completes the registration. Returns a full auth session. */
export const register = (payload: RegisterPayload) =>
    apiRequest<AuthSession, RegisterPayload>('/auth/register', {
        method: 'POST',
        body: payload,
        auth: false,
    });

export const login = (email: string, password: string) =>
    apiRequest<AuthSession, { email: string; password: string }>('/auth/login', {
        method: 'POST',
        body: { email, password },
        auth: false,
    });

export const forgotPassword = (email: string) =>
    apiRequest<{ message: string }>('/auth/forgot-password', {
        method: 'POST',
        body: { email },
        auth: false,
    });

export const resetPassword = (email: string, code: string, newPassword: string) =>
    apiRequest<{ success: boolean; message: string }>('/auth/reset-password', {
        method: 'POST',
        body: { email, code, newPassword },
        auth: false,
    });
